import { useNavigate } from 'react-router-dom';
import Button from '@/components/base/Button';
import TwivaMark from '@/components/feature/TwivaMark';

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center px-4 text-center">
      <TwivaMark className="mb-6 h-10 w-10" />
      <span className="font-heading text-7xl font-bold text-background-300 select-none">
        404
      </span>
      <h1 className="mt-4 font-heading text-xl font-semibold text-foreground-950">
        We could not find that page
      </h1>
      <p className="mt-2 max-w-sm text-sm text-foreground-600">
        The section you are looking for may have moved or is not part of the portal yet.
      </p>
      <div className="mt-6">
        <Button icon="ri-arrow-left-line" onClick={() => navigate('/dashboard')}>
          Back to dashboard
        </Button>
      </div>
    </div>
  );
}